'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleInitialMessageBubble = undefined;

var _reduxActions = require('redux-actions');

var _initialMessageBubbleActionTypes = require('../constants/initialMessageBubbleActionTypes');

var toggleInitialMessageBubble = exports.toggleInitialMessageBubble = (0, _reduxActions.createAction)(_initialMessageBubbleActionTypes.TOGGLE_INITIAL_MESSAGE_BUBBLE, function (visible) {
  return {
    visible: visible
  };
});